// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { ReopenBoardPopoverView } from 'app/scripts/views/board/ReopenBoardPopoverView';
import Confirm from 'app/scripts/views/lib/confirm';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

export const reopen = function (e) {
  stopPropagationAndPreventDefault(e);
  const org = this.model.getOrganization();
  return this.model
    .getNewBillableGuests()
    .then(({ newBillableGuests, availableLicenseCount }) => {
      if (newBillableGuests.length > 0) {
        return PopOver.show({
          elem: this.$('.js-reopen'),
          view: new ReopenBoardPopoverView({
            board: this.model,
            org,
            newBillableGuests,
            availableLicenseCount,
          }),
        });
      } else {
        const traceId = Analytics.startTask({
          taskName: 'edit-board/closed',
          source: 'closedBoardScreen',
        });
        return this.model.reopen(
          { traceId },
          tracingCallback(
            {
              taskName: 'edit-board/closed',
              source: 'closedBoardScreen',
              traceId,
            },
            (err) => {
              if (!err) {
                Analytics.sendTrackEvent({
                  action: 'reopened',
                  actionSubject: 'board',
                  source: 'closedBoardScreen',
                  containers: {
                    board: {
                      id: this.model.id,
                    },
                    organization: {
                      id: this.model.getOrganization()?.id,
                    },
                  },
                  attributes: {
                    taskId: traceId,
                  },
                });
              }
            },
          ),
        );
      }
    });
};

export const _delete = function (e) {
  stopPropagationAndPreventDefault(e);

  return Confirm.toggle('delete board', {
    elem: e.target,
    model: this.model,
    confirmBtnClass: 'nch-button nch-button--danger',
    fxConfirm: (e) => {
      const traceId = Analytics.startTask({
        taskName: 'delete-board',
        source: 'closedBoardScreen',
      });
      return this.model.startDelete(
        traceId,
        tracingCallback(
          {
            taskName: 'delete-board',
            source: 'closedBoardScreen',
            traceId,
          },
          (err) => {
            if (!err) {
              Analytics.sendTrackEvent({
                action: 'deleted',
                actionSubject: 'board',
                source: 'closeBoardScreen',
                containers: {
                  board: {
                    id: this.model.id,
                  },
                  organization: {
                    id: this.model.getOrganization()?.id,
                  },
                },
                attributes: {
                  taskId: traceId,
                },
              });
            }
          },
        ),
      );
    },
  });
};
